export const USERS_TYPES = {
   teacher: 'PROFESOR',
   student: "ALUMNO",
   staff: 'STAFF',
   director: 'DIRECTOR',
   codirector: 'CO-DIRECTOR',
   coordinator: 'COORDINADOR'
}